import { doGet } from './config/http';
import Prodotto from './components/Prodotto';
import { getOffsetTop } from './utils/offset-top';

// var onlyPublic presa da scope globale

function getHashParts(hash) {
    const parts = {
        page: null,
        id: null,
        data: null
    }
    const regexParts = hash.match(/^#([-a-z]+)\/([^/]+)(\/(.+))?/)
    if (regexParts) {
        parts.page = regexParts[1];
        parts.id = regexParts[2];
        parts.data = regexParts[4];
    }
    return parts;
}

export default {
    name: 'app',
    data: () => {
        return {
            onlyPublic: window.dn_products_app_public == 1,
            companiesHome: window.dn_products_app_public == 1,

            categories: {},
            companies: {},
            brands: {},

            categories_list: [],
            companies_list: [],
            brands_list: [],

            pageData: null,
            // product: null, Modale prodotti / pagina singolo prodotto rimossa 
            error: null,

            location: window.location.hash,
            page: null,
            pageId: null,
            title: '',
            loading: true,
            ignoreNextPageChange: true,
            pageChangeCount: 0,
            backButton: false,

            searchText: null,

            searchBox: ''
            /*
            categoryMasonry: null,
            productMasonry: null,
            searchProductMasonry: null,
            searchCategoryMasonry: null,
            searchCompanyMasonry: null,
            searchBrandsMasonry: null,
            copyToast: false
            */
        }
    },
    /** Modale prodotti / pagina singolo prodotto rimossa
     * 
    watch: {
        copyToast(active) {
            if (active) {
                setTimeout(() => { this.copyToast = false }, 2000)
            }
        },
    },
     */
    methods: {
        goTo: function (hash) {
            this.location = hash;
            const newPage = getHashParts(hash);

            /**
             * Modale prodotti / pagina singolo prodotto rimossa 
            if (newPage.page == 'product') {
                // Dato che è una modale, in caso apriamo la modale e basta
                this.getProduct(newPage.id);
                this.pageChangeCount++;
                return;
            }
             */

            this.title = ''; //this.searchBox ? this.searchBox : '';
            this.pageData = null;
            this.pageId = newPage.id;

            switch (newPage.page) {
                case 'category':
                    if (this.title === '' && this.categories[newPage.id]) {
                        this.title = this.categories[newPage.id].name;
                    }
                    this.getBrands(newPage.page, newPage.id);
                    this.page = newPage.page;
                    break

                case 'company':
                    if (this.title === '' && this.companies[newPage.id]) {
                        this.title = this.companies[newPage.id].name;
                    }
                case 'brand':
                    if (this.title === '' && this.brands[newPage.id]) {
                        this.title = this.brands[newPage.id].name;
                    }
                    this.getProducts(newPage.page, newPage.id, newPage.data);
                    this.page = newPage.page;
                    break;
                /**
                 * Modale prodotti / pagina singolo prodotto rimossa 
                case 'product':
                    // Trattandosi di una modale, product non cambia formalmente la pagina
                    break;
                 */

                case 'search':
                case 'search-categories':
                case 'search-companies':
                case 'search-brands':
                case 'search-products':
                    if (this.title === '') {
                        this.title = newPage.id.replace(/\+/g, ' ');
                    }
                    this.getResults(newPage.id, newPage.page.substr(7));
                    this.page = newPage.page;
                    break;
                default:
                    this.title = this.onlyPublic ? 'Aziende' : 'Categorie';
                    this.page = null;
            }

            if (!this.ignoreNextPageChange) {
                this.pageChangeCount++;
                this.scrollTop();
            } else {
                this.ignoreNextPageChange = false;
            }

            this.backButton = this.pageChangeCount > 1 || this.page !== null;
            // console.log('BB', this.backButton, this.pageChangeCount, this.page);
        },
        /**
         * Modale prodotti / pagina singolo prodotto rimossa 
        openProduct: function (id) {
            // this.getProduct(id);
            // this.ignoreNextPageChange = true;
            
            window.location.hash = '#product/' + id;
        },
        closeProduct: function () {
            this.product = null;
            if (this.pageChangeCount > 1) {
                this.goBack();
            } else {
                window.location.hash = '#';
            }
        },
        getProduct: function (id) {
            this.loading = true;
            doGet('product/' + id).then(response => {
                this.product = response.data;
                this.product.company = this.companies[this.product.company_id] ? this.companies[this.product.company_id].name : '';
                this.product.brand = this.companies[this.product.brand_id] ? this.companies[this.product.brand_id].name : '';
                this.loading = false;
            }).catch(() => {
                this.error = true;
            });
        },
        copyProductLink: function () {
            var tempInput = document.createElement("input");
            tempInput.style = "position: fixed; left: -1000px; top: -1000px";
            tempInput.value = window.location.href;
            document.body.appendChild(tempInput);
            tempInput.select();
            tempInput.setSelectionRange(0, 99999); // For mobile devices
            document.execCommand("copy");
            document.body.removeChild(tempInput);

            this.copyToast = true;
        },
         */
        scrollTop: function () {
            var element = document.getElementById("app");
            var top = getOffsetTop(element);
            window.scrollTo(0, top);
        },
        openInList: function (list, element) {
            const oldV = element.opened;
            list = list.map(e => { e.opened = false; return e; });
            element.opened = !oldV;
            // console.log(list, element);
            this.$forceUpdate();
            // ^ non dovrebbe essere necessaria, controllare
        },
        goToPage: function (hash) {
            if (hash === '#') {
                this.searchBox = '';
            }
            window.location.hash = hash;
        },
        goBack: function () {
            this.ignoreNextPageChange = true;
            if (this.pageChangeCount > 1) {
                this.pageChangeCount--;
                window.history.back();
            } else if (this.page !== null) {
                window.location.hash = '#';
            }
        },
        search: function () {
            if (this.searchBox.length > 2) {
                window.location.hash = '#search/' + encodeURI(this.searchBox.replace(/\s+/g, '+'));
            }
        },
        getBrands: function (type, id) {
            this.loading = true;
            doGet('products_in/' + type + '/' + id).then(response => {
                this.pageData = response.data.map(brand => {
                    brand.company = this.companies[brand.company_id] ? this.companies[brand.company_id].name : '';
                    return brand;
                });
                this.loading = false;
            }).catch(() => {
                this.error = true;
            });
        },
        getProducts: function (type, id, additional) {
            this.loading = true;
            let url = 'products_in/' + type + '/' + id;
            if (additional) {

                // Categoria > brand > prodotti
                let regexParts = additional.match(/^c\/([0-9]+)/)
                if (regexParts) {
                    url = 'products_in/category/' + regexParts[1] + '/' + id;
                }

                // Ricerca prodotti > brand > prodotti
                regexParts = additional.match(/^s\/([^/]+)/)
                if (regexParts) {
                    url = 'search_products/' + regexParts[1] + '/' + id;
                }
            }
            doGet(url).then(response => {
                // Dalla lista di prodotti, prendiamo i brand con map e set
                // Ordiniamo per nome del brand
                // E ad ogni brand associamo il nome della sua compagnia e l'elenco dei suoi prodotti
                this.pageData = [...new Set(response.data.map((e) => {
                    return this.brands[e.brand_id] ? this.brands[e.brand_id] : null;
                }))]
                    .filter(e => e !== null)
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(brand => {
                        brand.company = this.companies[brand.company_id] ? this.companies[brand.company_id].name : '';
                        brand.products = response.data.filter(p => p.brand_id === brand.id).map(product => {
                            product.category = this.categories[product.category_id] ? this.categories[product.category_id].name : '';
                            product.company = this.companies[product.company_id] ? this.companies[product.company_id].name : '';
                            product.brand = this.brands[product.brand_id] ? this.brands[product.brand_id].name : '';
                            return product;
                        });
                        return brand;
                    });
                this.loading = false;
            }).catch(() => {
                this.error = true;
            });
        },
        getResults: function (text, type) {
            this.searchText = text;
            if (this.searchText) {
                this.loading = true;
                switch (type) {
                    case 'categories':
                    case 'companies':
                        doGet('search_' + type + '/' + this.searchText).then(response => {
                            this.pageData = response.data;
                            this.loading = false;
                        }).catch(() => {
                            this.error = true;
                        });
                        break;
                    case 'products':
                        doGet('search_products/' + this.searchText).then(response => {
                            /*
                            this.pageData = response.data.map(product => {
                                product.category = this.categories[product.category_id] ? this.categories[product.category_id].name : '';
                                product.company = this.companies[product.company_id] ? this.companies[product.company_id].name : '';
                                product.brand = this.brands[product.brand_id] ? this.brands[product.brand_id].name : '';
                                return product;
                            });
                            */
                            this.pageData = response.data.map(brand => {
                                brand.company = this.companies[brand.company_id] ? this.companies[brand.company_id].name : '';
                                return brand;
                            });
                            this.loading = false;
                        }).catch(() => {
                            this.error = true;
                        });
                        break;
                    case 'brands':
                        doGet('search_brands/' + this.searchText).then(response => {
                            this.pageData = response.data.map(brand => {
                                brand.company = this.companies[brand.company_id] ? this.companies[brand.company_id].name : '';
                                return brand;
                            });
                            this.loading = false;
                        }).catch(() => {
                            this.error = true;
                        });
                        break;

                    default:
                        doGet('search_all/' + this.searchText).then(response => {
                            this.pageData = response.data;
                            this.pageData.products = this.pageData.products
                                .map(product => {
                                    product.category = this.categories[product.category_id] ? this.categories[product.category_id].name : '';
                                    product.company = this.companies[product.company_id] ? this.companies[product.company_id].name : '';
                                    product.brand = this.brands[product.brand_id] ? this.brands[product.brand_id].name : '';
                                    return product;
                                });
                            this.pageData.brands = this.pageData.brands
                                .map(brand => {
                                    brand.company = this.companies[brand.company_id] ? this.companies[brand.company_id].name : '';
                                    return brand;
                                });
                            this.loading = false;
                        }).catch(() => {
                            this.error = true;
                        });
                }
            }
        }
    },
    mounted() {
        this.loading = true;
        Promise.all([
            doGet('categories'),
            doGet('companies'),
            doGet('brands')
        ]).then(responses => {
            this.categories = {};
            this.categories_list = responses[0].data;
            responses[0].data.forEach(element => {
                this.categories[element.id] = element;
            })

            this.companies = {};
            this.companies_list = responses[1].data;
            responses[1].data.forEach(element => {
                this.companies[element.id] = element;
            })

            this.brands = {};
            this.brands_list = responses[2].data;
            responses[2].data.forEach(element => {
                this.brands[element.id] = element;
            })
            this.loading = false;

            this.goTo(window.location.hash);
        }).catch(() => {
            this.error = true;
        });

        window.addEventListener('hashchange', () => {
            this.goTo(window.location.hash);
        });
    }
}
